module.exports = __webpack_public_path__ + "static/media/play-button.9c828617.png";